import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const POLICIES = {
  privacy: {
    label: "Privacy Policy",
    title: "Your privacy matters.",
    body: [
      ["Data we collect", "Profile details you submit (name, photos, city, experience, measurements), account credentials, contact form entries and payment metadata. We never sell your data."],
      ["How we use it", "To present approved talent to casting professionals, respond to inquiries and manage your membership. Private phone and email are never publicly displayed unless you explicitly enable it."],
      ["Your rights", "Request edits, hiding or deletion of your profile at any time via the contact form or your member dashboard."],
      ["Contact", "Mohali, Punjab · 89686 81108 · Instagram @svproduction6"],
    ],
  },
  terms: {
    label: "Terms & Conditions",
    title: "Terms of use.",
    body: [
      ["Eligibility", "You must be legally allowed to submit your own profile and portfolio media, or hold the rights to submit them."],
      ["Content", "You retain ownership of your portfolio content. By submitting, you grant SV Talent Agency permission to display approved content on the public directory."],
      ["Conduct", "Misrepresentation, harassment or fraudulent activity results in immediate removal without refund."],
      ["Governing Law", "These terms are governed by the laws of India. Disputes fall under the jurisdiction of Mohali, Punjab courts."],
    ],
  },
  "membership-terms": {
    label: "Membership Terms",
    title: "Membership terms.",
    body: [
      ["Duration", "Memberships are valid for 365 days from the date of successful payment."],
      ["Renewal", "Memberships do not auto-renew by default. Renewal is a fresh purchase unless recurring is explicitly enabled."],
      ["What Membership Provides", "Access to the SV Talent Agency profile and portfolio platform, profile submission and inclusion in the discovery directory upon approval."],
      ["What Membership Does NOT Guarantee", "Membership does not guarantee representation, casting selection, employment, paid work, bookings, auditions or any specific opportunity."],
      ["Profile Approval", "SV Talent Agency reviews every submission. Approval, changes-required or rejection is at our sole discretion."],
      ["Account Security", "Keep your credentials confidential. You are responsible for all activity on your account."],
    ],
  },
  refund: {
    label: "Refund & Cancellation Policy",
    title: "Refund policy.",
    body: [
      ["Approved Profiles", "Once a profile is approved and listed publicly, membership fees are non-refundable."],
      ["Rejected Profiles", "If a submitted profile is rejected within 14 days of purchase, a full refund can be requested via the contact form."],
      ["Cancellation", "You may cancel your membership at any time from your dashboard. Cancellation stops any recurring renewal but does not refund past periods."],
      ["Fraudulent Payments", "Any payment made fraudulently or via a disputed method may result in immediate account suspension."],
      ["Contact for Refund", "Email SV Talent Agency via the contact form or WhatsApp 89686 81108."],
    ],
  },
};

export default function Legal({ kind }) {
  const p = POLICIES[kind] || POLICIES.privacy;
  return (
    <div className="min-h-screen">
      <Header />
      <section className="max-w-3xl mx-auto px-4 pt-20 pb-16">
        <div className="sv-overline mb-4">{p.label}</div>
        <h1 className="font-serif-hero text-4xl lg:text-6xl text-[#F4EFE4]">{p.title}</h1>
        <div className="mt-10 space-y-6 text-[#CDC7BA] leading-relaxed">
          {p.body.map(([h, t]) => (
            <div key={h}>
              <strong className="text-[#F4E4BC] font-serif-editorial text-xl block mb-2">{h}</strong>
              <p>{t}</p>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
